import { render, staticRenderFns } from "./AsociarCampos.vue?vue&type=template&id=54148f12&"
import script from "./AsociarCampos.vue?vue&type=script&lang=ts&"
export * from "./AsociarCampos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports